/**
 * Dark- und Light-Mode (§21).
 *
 * Die Einstellung wird ausschließlich lokal im Browser gespeichert, ist nicht an Token oder
 * Veranstaltung gebunden und wird nicht serverseitig protokolliert.
 */
/** Die vom Benutzer wählbaren Werte. `system` folgt der Betriebssystemeinstellung. */
export const THEME_PREFERENCES = ['system', 'light', 'dark'];
/** Vorgabe beim ersten Aufruf: Übernahme der Betriebssystemeinstellung (§21). */
export const DEFAULT_THEME_PREFERENCE = 'system';
/** Schlüssel im `localStorage` des Browsers. */
export const THEME_STORAGE_KEY = 'mcikm-vote.theme';
export function isThemePreference(value) {
    return typeof value === 'string' && THEME_PREFERENCES.includes(value);
}
/**
 * Löst eine Einstellung in das anzuwendende Erscheinungsbild auf.
 *
 * @param preference Gewählte Einstellung.
 * @param systemPrefersDark Ob das Betriebssystem ein dunkles Erscheinungsbild bevorzugt.
 */
export function resolveTheme(preference, systemPrefersDark) {
    if (preference === 'system') {
        return systemPrefersDark ? 'dark' : 'light';
    }
    return preference;
}
//# sourceMappingURL=theme.js.map